export const ApiPaths = {
  signUp: '/sign-up',
  signIn: '/oauth/token',
  curriculums: '/curriculums',
  stripe: '/stripe',
  courses: '/courses',
};

export const AdminApiPaths = {
  courses: `/admin/courses`,
  courseTutors: `/admin/course-tutors`,
  courseStudents: `/admin/course-students`,
  sections: `/admin/sections`,
  users: `/admin/users`,
  external: '/admin/external',
  courseTemplates: `/admin/course-templates`,
};
